import CourseForm from "../../components/CourseForm/CourseForm";
const AddNewCourse = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <CourseForm type="Add" />
        </div>
    )
}
export default AddNewCourse;